<template>
  <div class="menu-con d-flex flex-column" :class="{'menu-close':menuState=='close'}">
    <vue-custom-scrollbar class="nav-con h-100 grmb-8 text-secondary">
      <div>
        <b-nav vertical class="w-100 vertical-nav">
          <menu-component></menu-component>
        </b-nav>
      </div>
    </vue-custom-scrollbar>

    <div class="grml-8 grmr-8 grmb-4 support-con mt-auto text-center">
      <img
        v-if="companies.filter( company => company.id==current_company_id)[0].logo"
        :src="companies.filter( company => company.id==current_company_id)[0].logo"
      />

     
    </div>
  </div>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import menuComponent from "@/layouts/partials/TheAppMenu";

export default {
  components: {
    vueCustomScrollbar,
    menuComponent,
  },
  computed: {
    menuState() {
      return this.$store.getters["menu/menuState"];
    },
    companies() {
      return this.$store.state.user.companies;
    },
    current_company_id() {
      return this.$store.state.user.current_company_id;
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.menu-con {
  z-index: 100;
  position: fixed;
  width: 236px;
  top: 49px;
  bottom: 0;
  padding-top: 33px;
  left: 0;
  background-color: var(--bg-white);
  overflow: hidden;
  transition: all 0.3s ease;
  //border-bottom-left-radius: 22px;
  //border-bottom-right-radius: 22px;
  //border-top-right-radius: 84px;
  //border-top-left-radius: 22px;
  box-shadow: 0 1px 15px rgba(0,0,0,.04), 0 1px 6px rgba(0,0,0,.04);
}

@media (min-width: 1200px) {
  .menu-con{
    padding-top: 63px;
  }
}
.menu-close {
  width: 0;
}

.btn-support {
  background: var(--primary);
  color: #fff;
  border-radius: 22px;
}

.support-con {
  height: 56px;
  overflow: hidden;
  img {
    max-height: 100%;
    max-width: 100%;
  }
}
</style>